import { EXTERNAL_SHARE } from '@confluence/named-routes/entry-points/routes';

export const isExternalShareRequest = () => !!EXTERNAL_SHARE.match(window.location.pathname);
